import { KNOWN_ATTRIBUTION_QUERY_KEYS } from "../tracking.constants";
import { SearchParamsLike } from "../tracking.types";

const isTrackingQueryParamKey = (key: string): boolean => {
  const normalized = key.trim().toLowerCase();
  if (!normalized) return false;

  return (
    normalized.startsWith("utm_") ||
    normalized.startsWith("utm-") ||
    normalized.endsWith("clid") ||
    KNOWN_ATTRIBUTION_QUERY_KEYS.has(normalized)
  );
};

export const extractTrackingQueryParams = (searchParams: SearchParamsLike): URLSearchParams => {
  const trackingParams = new URLSearchParams();

  for (const [key, value] of searchParams.entries()) {
    if (!isTrackingQueryParamKey(key)) {
      continue;
    }

    const normalizedValue = value.trim();
    if (!normalizedValue) {
      continue;
    }

    trackingParams.append(key, normalizedValue);
  }

  return trackingParams;
};

export const appendTrackingSearch = (path: string, searchParams: SearchParamsLike): string => {
  const trackingParams = extractTrackingQueryParams(searchParams).toString();
  return trackingParams ? `${path}?${trackingParams}` : path;
};
